export enum soundAssetConfig {
    baseGameLoop = "assets/sounds/ii_mx_basegame_loop.mp3",
    freeGameLoop = "assets/sounds/ii_mx_freegame_loop.mp3",
    introLoop = "assets/sounds/ii_mx_freespin_trigger.mp3",
    bigWinLoop = "assets/sounds/ii_sx_bigwin.mp3",
    superWinLoop = "assets/sounds/ii_sx_superwin.mp3",
    megaWinLoop = "assets/sounds/ii_sx_megawin.mp3",
    spinButtonSound = "assets/sounds/ii_sx_spin_button_click.mp3",
    genericButtonSound = "assets/sounds/ii_sx_general_click.mp3",
    continueButtonSound = "assets/sounds/ii_sx_general_click.mp3",
    fgOutroSound = "assets/sounds/ii_mx_freespin_end.mp3",
    reelSpinSound = "assets/sounds/srs_sx_reel_spin_loop.mp3",
    reelStoppingSound = "assets/sounds/srs_sx_reel_stop.mp3",
    tickupSound = "assets/sounds/ii_sx_counter.mp3",
    coinShowerSound = "assets/sounds/ii_sx_coins.mp3",
    winLevel_1 = "assets/sounds/ii_sx_winsound_1.mp3",
    winLevel_2 = "assets/sounds/ii_sx_winsound_2.mp3",
    winLevel_3 = "assets/sounds/ii_sx_winsound_3.mp3",
    symbol_blast = "assets/sounds/ii_sx_symbol_blast.mp3",
    symbol_1 = "assets/sounds/srs_sx_symbol_1.mp3",
    symbol_2 = "assets/sounds/srs_sx_symbol_2_5.mp3",
    symbol_6 = "assets/sounds/srs_sx_symbol_6.mp3",
    symbol_7 = "assets/sounds/srs_sx_symbol_7.mp3",
    symbol_8 = "assets/sounds/srs_sx_symbol_8.mp3",
    symbol_9 = "assets/sounds/srs_sx_symbol_9.mp3",
    scatterLandingSound = "assets/sounds/srs_sx_scatter_symbol.mp3",
    multiplierFG = "assets/sounds/ii_sx_multiplier.mp3",
    tumbleSound = "assets/sounds/ii_sx_symbol_tumble.mp3",
    energyToSymbol = "assets/sounds/ii_sx_character_to_symbol_energy.mp3",
    symbolToWilds = "assets/sounds/ii_sx_symbols_to_random_wilds.mp3",
    giantwild1 = "assets/sounds/ii_sx_giant_wild_01.mp3",
    giantwild2 = "assets/sounds/ii_sx_giant_wild_02.mp3",
    popOutSound = "assets/sounds/ii_sx_giant_wild_popout.mp3",
    reelAppear = "assets/sounds/ii_sx_stone_symbol_appear.mp3",
    reelDisappear = "assets/sounds/ii_sx_stone_symbol_disappear.mp3",
}
